import React from 'react'

function CreateAct() {
  return (
    <div>CreateAct</div>
  )
}

export default CreateAct
